export const numberToWords = (num) => {
    if (num === "" || num === undefined || num === null) return "";
    if (num === 0) return "Zero";

    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
    ];
    const teens = [
      "",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
      "",
      "Twentyone",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    let words = "";

    if (num >= 10000000) {
      const crorePart = Math.floor(num / 10000000);
      const remainder = num % 10000000;

      if (crorePart > 10 && crorePart < 20) {
        words += teens[crorePart - 10] + " Crore ";
      } else {
        words +=
          tens[Math.floor(crorePart / 10)] +
          " " +
          units[crorePart % 10] +
          " Crore ";
      }

      num = remainder;
    }

    if (num >= 100000) {
      const lakhPart = Math.floor(num / 100000);
      const remainder = num % 100000;

      if (lakhPart > 10 && lakhPart < 20) {
        words += teens[lakhPart - 10] + " Lakh ";
      } else {
        if (Math.floor(lakhPart / 10) > 0) {
          words += tens[Math.floor(lakhPart / 10)] + " ";
        }
        words += units[lakhPart % 10] + " Lakh ";
      }

      num = remainder;
    }

    if (num >= 1000) {
      const thousandPart = Math.floor(num / 1000);
      const remainder = num % 1000;

      if (thousandPart > 10 && thousandPart < 20) {
        // Handle teens
        words += teens[thousandPart - 10] + " Thousand ";
      } else {
        // Handle tens and units
        if (Math.floor(thousandPart / 10) > 0) {
          words += tens[Math.floor(thousandPart / 10)] + " ";
        }
        words += units[thousandPart % 10] + " Thousand ";
      }

      num = remainder;
    }

    if (num >= 100) {
      words += units[Math.floor(num / 100)] + " Hundred ";
      num %= 100;
    }

    if (num >= 11 && num <= 19) {
      words += teens[num - 10] + " ";
    } else {
      if (num >= 20) {
        words += tens[Math.floor(num / 10)] + " ";
        num %= 10;
      }
      words += units[num] + " ";
    }

    return words.trim();
  };
